<template>
  <div class="sumber-footer">
    <div class="fotter-box">
      <div class="item">
        <img src="../assets/address.png" alt="">
        <span>Rukan Eksklusif Mediterania Blok H No.27, Kel.
          Kec.Penjaringan, Kota Adm. Jakarta Utara, Prop. DKI Jakarta</span>
      </div>
      <div class="item">
        <img src="../assets/email.png" alt="">
        <span>muhammad@koperasisumbermakmurteknologi.com</span>
      </div>
      <div class="item">
        <img src="../assets/tel.png" alt="">
        <span>895321547584</span>
      </div>
    </div>
    <div class="fotter-info">
      © PONFOOD COMPANY LIMITED
    </div>
  </div>
</template>
<script>
export default {
  name: "fotter",
  data() {
    return {
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.sumber-footer {
  font-size: 18px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #333333;
  background: #1D1C1C;

  .fotter-box {
    padding: 64px 360px;
    display: flex;

    .item {
      margin-right: 60px;
      padding: 16px 30px;
      width: 33%;
      display: flex;
      align-items: baseline;
      border: 1px solid #F4A639;
      box-sizing: border-box;
      img {
        margin-right: 8px;
        width: 16px;
        height: 13px;
      }

      span {
        font-weight: 600;
        font-size: 17px;
        color: #FFFFFF;
        line-height: 26px;
        word-break: break-all;
      }
    }

    .item:last-child {
      margin-right: 0;
    }
  }

  .fotter-info {
    border-top: 1px solid #565656;
    padding: 20px 0;
    font-weight: 600;
    font-size: 17px;
    color: #666666;
    line-height: 26px;
    text-align: center;
  }
}
</style>
